import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Plus, SearchIcon, X } from "lucide-react";
import TableContainer from "Common/TableContainer";
import Swl from "sweetalert2";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import {
  addcreateUserData,
  deletecreateUserData,
  getcreateUserData,
  updatecreateUserData,
} from "slices/createUser/reducer";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import createColumnUser from "Common/Components/ColumnData/createColumnUser";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import { exportToExcel } from "Common/Components/Excel";
import ModalUser from "Common/Components/ModalUser/ModalUser";
import PaginationTest from "Common/Components/Paginationtest";

interface Factory {
  provincenames: string;
  cityname: string;
}
interface FormField {
  name: string;
  label: string;
  type: string;
  placeholder: string;
}

const ManageUser = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState<any>("");
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [id, setid] = useState<any>();
  const [username, setusername] = useState<any>();
  const [fullname, setfullname] = useState<any>();
  const [phone_number, setphone_number] = useState<any>();
  const [password, setpassword] = useState<any>("");
  const [email, setemail] = useState<any>();
  const [disabled, setdisabled] = useState(true);
  const [role_id, setrole_id] = useState<any>();
  const [factory_ownedvalue, setfactory_ownedvalue] = useState<any>(null);
  const [poultry_ownedvalue, setpoultry_ownedvalue] = useState<any>(null);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch<any>();
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [total, settotal] = useState<any>(10);
  const [totalPages, settotalPages] = useState<any>(10);
  const [sizeCurrent, setsizeCurrent] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>(null);

  const formFields: FormField[] = [
    {
      name: "fullname",
      label: "نام و نام خانوادگی",
      type: "text",
      placeholder: "نام و نام خانوادگی",
    },
    {
      name: "phone_number",
      label: "تلفن تماس",
      type: "text",
      placeholder: "تلفن تماس",
    },
    {
      name: "username",
      label: "کد ملی / نام کاربری",
      type: "text",
      placeholder: "نام کاربری",
    },
    {
      name: "password",
      label: " رمز عبور (در صورت ویرایش اختیاری)",
      type: "text",
      placeholder: "رمز عبور",
    },
    {
      name: "email",
      label: "ایمیل",
      type: "text",
      placeholder: "ایمیل",
    },
  ];
  const fetchData = (page: any, size: any) => {
    let url = `https://api.havirkesht.ir/users/?sort_by=updated_at&&size=${size}&page=${page}&sort_order=desc`;

    // اضافه کردن پارامتر جستجو اگر وجود دارد
    if (searchValue && searchValue.trim() !== "") {
      url += `&search=${encodeURIComponent(searchValue.trim())}`;
    }

    dispatch(getcreateUserData(url))
      .then(unwrapResult)
      .then((result: any) => {
        settotal(result?.data?.total);
        settotalPages(result?.data?.pages);
        setData(result.data.items);
        setErrorMessage(null);
      })
      .catch((error: any) => {
        console.error("Error fetching data:", error);
        if (error.message) {
          setErrorMessage(
            "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
          );
        } else {
          setErrorMessage("خطایی رخ داده است. لطفاً مجدداً تلاش کنید.");
        }
      });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchData(currentPage, sizeCurrent); // اولین بار داده‌ها را دریافت کنید
  }, [reload, dispatch, currentPage, sizeCurrent, searchValue]);

  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setusername(ele.username || "");
    setfullname(ele.fullname || "");
    setphone_number(ele.phone_number || "");
    setpassword(ele.password ? ele.password : "");
    setemail(ele.email || "");
    setdisabled(ele.disabled || false);
    setid(ele.id || "");
    setrole_id(ele.role_id || "");
    setShow(true);
  };

  const options = [
    { label: "ادمین / پیمانکار", value: "1" },
    { label: "کشاورز", value: "3" },
    { label: "راننده", value: "5" },
  ];

  const handleSelectrole = (value: string) => {
    setrole_id(value);
    setIsOpen(false);
  };
  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }
    setsizeCurrent(newSize);
    setCurrentPage(newPage);
    fetchData(newPage, newSize);
  };

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = () => {
    if (!eventData) {
      toast.error("شناسه یافت نشد");
      return;
    }
    dispatch(deletecreateUserData(eventData))
      .then(unwrapResult)
      .then((result: any) => {
        if (result && typeof result === "object") {
          setShow(false);
          toast.success("حذف  با موفقیت انجام شد");
          setreload(!reload);
        }
      })
      .catch((error: any) => {
        toast.error("خطا در حذف داده به وجود امده لطفا مجدد تلاش کنید");
      });
    setDeleteModal(false);
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: isEdit ? username : "",
      fullname: isEdit ? fullname : "",
      phone_number: isEdit ? phone_number : "",
      email: isEdit ? email : "",
      password: isEdit ? password : password,
      disabled: isEdit ? disabled : false,
    },
    validationSchema: Yup.object({
      username: Yup.string().required("لطفاً نام کاربری را وارد کنید"),
      fullname: Yup.string().required("لطفاً نام کامل را وارد کنید"),
      phone_number: Yup.string()
        .matches(/^\d{11}$/, "شماره تلفن باید ۱۱ رقم باشد")
        .required("لطفاً شماره تلفن را وارد کنید"),
      email: Yup.string()
        .email("ایمیل معتبر نیست")
        .required("لطفاً ایمیل را وارد کنید"),
      // role_id: Yup.number().required("لطفاً نقش را انتخاب کنید"),
    }),
    onSubmit: async (values) => {
      if (isEdit) {
        const updatevalue: any = {
          ...values,
          role_id: Number(role_id),
          disabled: disabled,
          user_id: id,
          username: values.username.trim(),
        };
        if (updatevalue.password) {
          updatevalue.password = updatevalue.password.trim();
        }
        dispatch(updatecreateUserData(updatevalue))
          .then(unwrapResult)
          .then((result: any) => {
            if (result && typeof result === "object") {
              setusername("");
              setfullname("");
              setphone_number("");
              setpassword(null);
              setemail("");
              setdisabled(false);
              setid("");
              setIsEdit(!isEdit);
              setrole_id("");
              setreload(!reload);
              setShow(false);
              toast.success("ویرایش  با موفقیت انجام شد");
            }
          })
          .catch((error: any) => {
            setShow(true);
            toast.error("خطا در ویرایش اطلاعات لطفا مجدد تلاش کنید");
          });
      } else {
        const newData = {
          ...values,
          role_id: Number(role_id),
          disabled: disabled,
          factory_owned: Number(factory_ownedvalue),
          poultry_owned: Number(poultry_ownedvalue),
        };
        dispatch(addcreateUserData(newData))
          .then(unwrapResult)
          .then((result: any) => {
            if (result && typeof result === "object") {
              setShow(false);
              setreload(!reload);
              setrole_id("");
              setpassword(null);
              toast.success("کاربر  با موفقیت ایجاد شد");
            }
          })
          .catch((error: any) => {
            toast.error(
              "لطفا مرغ‌دار یا کارخانه‌دار و نقش  انتخاب کنید. خطا در ایجاد کاربر"
            );
            setShow(true);
          });
      }
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setrole_id(null);
      setEventData("");
      setfactory_ownedvalue(null);
      setpoultry_ownedvalue(null);
      setIsEdit(false);
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const chengeStatus = (data: any) => {
    try {
      const updatevalue: any = {
        ...data,
        role_id: Number(data.role_id),
        user_id: data.id,
        disabled: data.disabled === true ? false : true,
        username: data.username,
      };
      if (updatevalue.password) {
        updatevalue.password = updatevalue.password.trim();
      }
      dispatch(updatecreateUserData(updatevalue))
        .then(unwrapResult)
        .then((result: any) => {
          if (result && typeof result === "object") {
            setusername("");
            setfullname("");
            setphone_number("");
            setpassword(null);
            setemail("");
            setdisabled(false);
            setid("");
            setIsEdit(!isEdit);
            setrole_id("");
            setreload(!reload);
            setShow(false);
            Swl.fire(
              "عملیات موفقیت",
              "عملیات تغییر وضعیت با موفقیت ثبت شد",
              "success"
            );
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const columns = createColumnUser({
    handleUpdateDataClick,
    chengeStatus,
    onClickDelete,
  });

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ایجاد کاربر" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع کاربران (
              <b className="total-Employs">{total?.toString()}</b>)
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                    {searchValue ? (
                      <X
                        size={15}
                        className="cursor-pointer"
                        onClick={() => setsearchValue("")}
                      />
                    ) : (
                      <SearchIcon size={15} />
                    )}
                  </span>
                </div>
              </label>
            </h6>
            <div className="">
              {" "}
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <button
              className="text-custom-600 hidden sm:block dark:text-white dark:bg-blue-800 btn bg-white border-custom-500  hover:text-green-800"
              onClick={() => exportToExcel(data, "کاربران")}
            >
              دانلود اکسل
            </button>
            <div className="shrink-0">
              <Link
                to="#!"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">ایجاد کاربر</span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
        <div className="mb-3">
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <ModalUser
        show={show}
        isEdit={isEdit}
        onHide={toggle}
        onSubmit={handleClick}
        validation={validation}
        formFields={formFields}
        role_id={role_id}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        options={options}
        handleSelectrole={handleSelectrole}
        disabled={disabled}
        setdisabled={setdisabled}
      />
    </React.Fragment>
  );
};

export default ManageUser;
